module.exports = __webpack_public_path__ + "static/media/mediacion_title.a9719a78.svg";